<template>
  <div class="pageShow" v-if="tabShow" :class="{ pg2: pageBg }">
    <div class="title-heading" style="margin-left: 35px" v-if="this.pageIndex == 4">
      <p>
        <i style="position: relative; top: 5px; margin-right: 5px">
          <img src="@/assets/titleBlock/heading1.png" alt="" />
        </i>
        {{ titlePage }}
        <i style="position: relative; top: 5px; margin-left: 5px">
          <img src="@/assets/titleBlock/heading2.png" alt="" />
        </i>
      </p>
    </div>
    <div style="display: block">
      <div v-if="!this.pageIndex" class="title-img">
        <TitleBlockImg></TitleBlockImg>
      </div>
      <li v-for="(item, index) in columnInfo" :key="index">
        <div class="heading" v-if="item.uiType == 8">
          <p>
            <i style="position: relative; top: 5px; margin-right: 5px">
              <img src="@/assets/titleBlock/heading1.png" alt="" />
            </i>
            {{ item.val }}
            <i style="position: relative; top: 5px; margin-left: 5px">
              <img src="@/assets/titleBlock/heading2.png" alt="" />
            </i>
          </p>
        </div>
        <div v-else-if="item.uiType == 2" style="width: 100%; display: flex">
          <div style="flex-shrink: 0; flex-basis: 240px" class="list-title">
            <el-tooltip
              v-if="item.descriptions.length !== 0"
              effect="dark"
              placement="top-start"
            >
              <i class="el-icon-info"></i>
              <div slot="content" style="width: 320px" v-html="item.descriptions"></div>
            </el-tooltip>
            <span v-if="item.required" style="color: red">{{ "*" }}</span>
            {{ item.name }}<span style="margin: 0 3px">:</span>
          </div>
          <div class="isMat" :class="{ nodata: !item.val }">
            <!-- <textarea :rows="4" placeholder="请输入内容"> {{ item.val || noData }} </textarea> -->
            <span v-if="!item.val"> {{ noData }} </span>
            <template v-else>
              <div
                v-html="setVal(item.val)"
                :class="{ 'red-class': !item.dataCompare }"
              ></div>
            </template>
            <div v-show="!item.dataCompare" :title="item.oldVal">
              <div v-html="setVal(item.oldVal)" class="black-class"></div>
              <!-- <span class="black-class">
                {{ item.oldVal }}
              </span> -->
            </div>
          </div>
        </div>
        <div class="table-list" v-else :class="{ active: ColPage, active2: !ColPage }">
          <div style="display: flex; margin: 5px 0">
            <div style="flex-shrink: 0; flex-basis: 240px" class="list-title">
              <el-tooltip
                v-if="item.descriptions.length !== 0"
                effect="dark"
                placement="top-start"
              >
                <i class="el-icon-info"></i>
                <div
                  slot="content"
                  style="width: 320px"
                  v-html="item.descriptions"
                ></div> </el-tooltip
              >{{ item.name }}
              <span style="margin: 0 3px">:</span>
            </div>
            <!-- 修改过的新值会以红色字体呈现，旧值会以黑色字体红色线条贯穿呈现 -->
            <!-- 因为贯穿线条与字体颜色一致，所以先让线条与字体颜色都为红色，再让字体颜色变为黑色达成效果 -->
            <div style="flex: 1; font-size: 14px">
              <div
                v-if="![3, 4].includes(item.uiType)"
                :title="item.val"
                :class="{
                  nodata: !item.val,
                  'red-class': !item.dataCompare,
                }"
                style="font-size: 14px; margin-top: 2px"
              >
                {{ item.val || noData }}
                <div v-show="!item.dataCompare" :title="item.oldVal">
                  <span class="black-class">
                    {{ item.oldVal }}
                  </span>
                </div>
              </div>
              <div v-else>
                <renderRedLine :data="item" :key="getRenderKey(item)" />
              </div>
            </div>
          </div>
        </div>
      </li>
      <div
        v-show="!this.pageIndex && deliverList.length"
        style="width: 100%; margin-bottom: 25px"
      >
        <div style="width: 96%"><el-divider></el-divider></div>
        <div class="title-heading" style="margin-left: 35px">
          <p>
            <span style="font-size: 16px; font-weight: 600; margin: 0 8px 0 45px"
              >归属项目列表</span
            >
            <i style="position: relative; top: 5px; margin-left: 5px">
              <img src="@/assets/titleBlock/heading2.png" alt="" />
            </i>
          </p>
        </div>
        <li v-for="item in deliverList" :key="item.id">
          <div style="line-height: 24px">
            <div class="aa">
              <span class="list-key" :title="item.type">{{ "归属" + item.type }}</span>
            </div>
            <div class="middle">:</div>
            <div class="bb">
              <span
                class="manufact"
                style="margin-right: 60px"
                :title="item.name"
                @click="cellClick(item)"
                >{{ item.name }}</span
              >
              <span v-for="i in item.children" :key="i.id" style="margin: 0 5px"
                >{{ "关联" + i.type + ": " }}
                <span class="manufact" @click="cellClick(i)" :title="i.name">{{
                  i.name
                }}</span>
              </span>
            </div>
          </div>
        </li>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TitleBlockImg from "./titleBlockImg.vue";
import { densityList } from "@/utils/density.js";
import renderRedLine from "./renderRedLine.vue";
export default {
  data() {
    return {
      tabShow: true,
      pageInfo: {},
      columnInfo: [],
      column: [],
      ColPage: false,
      titlePage: "",
      pageBg: false,
      searchMf: "",
      pageOrder: [
        this.$t("message.title.pageOne"),
        this.$t("message.title.pageTwo"),
        this.$t("message.title.pageThree"),
      ],
      noData: this.$t("message.tips.noData"),
      pageData: {},
      input_width: {
        width: "50%",
      },
      deliverList: [],
    };
  },
  components: {
    TitleBlockImg,
    renderRedLine,
  },
  computed: {},
  props: ["page", "pageIndex", "reset"],
  methods: {
    setVal(val) {
      const p = val.replaceAll("\n", "</br>").replaceAll(" ", "&nbsp;"); // const p = item.val.replaceAll(' ', '&nbsp;');
      return `<p style ='margin:0;'> ${p} </p>`;
    },
    getRenderKey(item) {
      return Date.parse(new Date()) + item.id;
    },
    listClick(item) {
      if (!item.link) {
        return;
      }
      axios
        .get("pmdm/admin/list/getObjectInfoByListId?listEntryId=" + item.id)
        .then((res) => {
          console.log(res);
          const obj = { ...res.data.object, title: item.title };
          this.getLink(obj);
          this.$store.commit("setPageRefresh");
        });
    },
    getColumn() {
      this.tabShow = !!this.page.column.ids.length;
      if (!this.tabShow) {
        this.columnInfo = [];
        return;
      }
      const getVal = (obj) => {
        try {
          const a = JSON.parse(obj);
          return a;
        } catch (error) {
          return obj;
        }
      };
      let arr = this.getNewData(this.page.column);
      const val = this.page.val.cells;
      const oldVal = this.page.val.oldCells;
      this.columnInfo = arr.map((i, e) => {
        i.val = val[e].val;
        i.oldVal = oldVal[e].val;
        // dataCompare的值是 新数据（val）和旧数据（oldval）的比较结果（true/false）
        // 如果该值为 true 说明该字段前后没有修改，不做操作
        // 如果该值为false 说明该字段发生了修改，新值用红色显示，旧值以黑色画横线显示
        // 目前数据的uiType分为3、4和非3，4 三种，下面对uiType = 3/4 进行特殊处理判断
        i.dataCompare = i.oldVal == i.val;
        if (i.uiType == 3 && val[e].val) {
          i.val = [{ title: val[e].val, id: val[e].id, link: i.listType === 3 }];
          i.dataCompare = i.val[0].title == i.oldVal;
        }
        if (i.uiType == 4 && val[e].val) {
          const idList = val[e].ids.split(";");
          const valList = val[e].val.split(";");
          i.val = idList.map((j, x) => ({
            id: j,
            title: valList[x],
            link: i.listType === 3,
          }));
          const temp = i.val.map((j) => j.title).join(";");
          i.dataCompare = temp == i.oldVal;
        }
        return i;
      });
      console.log(this.columnInfo);
    },
    manuClick() {
      let val = this.columnInfo.find((i) => i.id == 1012002).val[0].val;
      axios.get("/pmdm/manufacturers/getManufacturers?name=" + val).then((res) => {
        let obj = res.data.object.manufacturers[0];
        obj.title = val;
        this.getLink(obj);
      });
    },
    cellClick(e) {
      this.getLink(e);
    },
    getObjectRalationship() {
      let obj = {
        effObjid: this.$store.state.objectId.id,
        classId: this.$store.state.objectId.classId,
        subClassId: this.$store.state.objectId.subClassId,
      };
      axios
        .get("/pmdm/relationship/getObjectListByRelationShip", {
          params: obj,
        })
        .then((res) => {
          let arr = res.data.object.table;
          this.deliverList = Object.keys(arr).map((key) => {
            const i = arr[key];
            let n = {
              id: i[0].objId,
              classId: i[0].classId,
              subClassId: i[0].subClassId,
              name: i[0].name,
              type: i[0].subClassName,
              children: [],
            };
            i.map((j) => {
              j.childObjId &&
                n.children.push({
                  name: j.childName,
                  type: j.childSubClassName,
                  id: j.childObjId,
                  classId: j.childClassId,
                  subClassId: j.childSubClassId,
                });
            });
            return n;
          });
        });
    },
    countMass() {
      const item = densityList.find(
        (i) => i.subClassId == this.$store.state.objectId.subClassId
      );
      if (!item?.densityParams) {
        return;
      }
      const [x, y] = item.densityParams.map((i) => {
        const n = this.columnInfo.find((j) => j.id == i);
        return n.val.id;
      });
      let n = 0;
      if (item.densityParams.length < 2) {
        n = item.list.find((i) => i.aId == x || !i.aId).value;
      } else {
        const m = item.list.find((i) => i.aId == x || !i.aId);
        if (!m.hasOwnProperty("bId")) {
          n = m.value;
        } else {
          n = item.list.find((i) => (i.aId == x && i.bId == y) || !i.aId).value;
        }
      }
      const [a, b, c] = item.shapeParams.map((i) => {
        const n = this.columnInfo.find((j) => j.id == i);
        return n.val.val;
      });
      const obj = this.columnInfo.find((i) => i.id == item.massId);
      obj.val.val = (item.formula(a, b, c) * n).toFixed(2);
    },
  },
  mounted() {
    this.titlePage = this.pageOrder[this.pageIndex];
    this.ColPage = !!this.pageIndex;
    this.pageBg = !!(this.pageIndex == 1);
  },
  created() {
    this.getColumn();
    !this.pageIndex && this.getObjectRalationship();
  },
  watch: {
    reset() {
      this.getColumn();
    },
    page: {
      handler(e) {
        if (e) {
          this.getColumn();
        }
      },
    },
  },
};
</script>

<style>
li {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}
</style>

<style scoped>
.title-img {
  height: 200px;
  width: 500px;
  background-color: #fbfdff;
  float: right;
  margin-right: 10%;
}

.pageShow {
  width: 100%;
  margin: 10px 0 0 0;
  padding: 15px 0 20px 15px;
  position: relative;
  display: block;
  overflow: hidden;
}

.list-title {
  text-align: right;
  font-size: 14px;
  min-width: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.active {
  width: 33%;
  float: left;
}

.active2 {
  width: 33%;
  display: block;
}

.manufact {
  color: #4b91ff;
  cursor: pointer;
}

.nodata {
  pointer-events: none;
  user-select: none;
  color: #c0c4cc;
  font-size: 14px;
}

.manufact:hover {
  text-decoration: underline;
}

.list-item {
  overflow: hidden;
  margin-top: 3px;
}

.aa {
  font-size: 14px;
  width: 20%;
  float: left;
  text-align: right;
}

.middle {
  float: left;
  margin: 0 6px;
}

.bb {
  font-size: 14px;
  width: 70%;
  float: left;
}

.items li {
  list-style: none;
}

.item-textarea {
}

.pg2 {
  padding: 15px 15px 20px 15px;
  overflow: hidden;
  background: #f3f7fa;
  background-image: url(~@/assets/titleBlock/page2.png);
  background-repeat: no-repeat;
  background-position: bottom right;
}

.heading {
  width: 100%;
  float: left;
  margin: 0px 0 8px 55px;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 8px 40px;
}

.heading p {
  font-size: 16px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 10px 0px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.page1 {
  width: 50%;
  overflow: hidden;
}

.page2 {
  width: 50%;
  float: left;
}

.page3 {
  width: 50%;
  float: left;
}

ul {
  margin: 0;
}

.line01 {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
}

.list-val:empty::before {
  content: attr(data-attr);
  color: #c0c4cc;
}

.table-list {
  /* margin: 5px; */
  overflow: hidden;
}

.table-list-rela {
  overflow: hidden;
  margin-top: 3px;
}

.table-list li {
  overflow: hidden;
}

.table-list .list-key {
  font-size: 14px;
}

.red-class {
  color: red;
}

.black-class {
  text-decoration: line-through red;
  color: #000;
}

.table-list .list-val-rela {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  position: relative;
}

.isMat {
  line-height: 16px;
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 21px;
  margin-top: 2px;
}
</style>
